import type { FC } from "react"
import type { ReferenceLineProps } from "recharts"
import { ReferenceLine } from "recharts"

const QuorumReferenceLine: FC<ReferenceLineProps> = ({
  ...referenceLineProps
}) => (
  <ReferenceLine
    fill="#718096"
    ifOverflow="extendDomain"
    label={{
      value: "Quorum needed",
      fill: "#718096",
      position: "insideTopRight",
      fontSize: "12px",
    }}
    stroke="#718096"
    strokeDasharray="3 3"
    strokeWidth={2}
    {...referenceLineProps}
  />
)

export default QuorumReferenceLine
